import { Box, Button, LinearProgress, Stack, Typography } from '@mui/material';
import UpgradeIcon from '@mui/icons-material/ArrowUpward';
import React from 'react';
import type { QuotaInfo } from '../utils/quota';
import { useNavigate } from 'react-router-dom';

interface QuotaDisplayProps {
  label: string;
  quotaInfo: QuotaInfo;
}

const QuotaDisplay: React.FC<QuotaDisplayProps> = ({ label, quotaInfo }) => {
  const navigate = useNavigate();

  // Don't show if unlimited
  if (quotaInfo.isUnlimited) return null;

  const progress = quotaInfo.limit > 0
    ? Math.min(100, (quotaInfo.current / quotaInfo.limit) * 100)
    : 0;

  const progressColor = quotaInfo.isAtLimit
    ? 'error'
    : quotaInfo.isNearLimit
      ? 'warning'
      : 'primary';

  return (
    <Stack alignItems="center" sx={{ mb: 2 }}>
      <Box sx={{ width: '100%', maxWidth: 320 }}>
        <Stack direction="row" justifyContent="center" alignItems="center" spacing={1} sx={{ mb: 0.5 }}>
          <Typography variant="body2" color="text.secondary">
            {label}: {quotaInfo.current} / {quotaInfo.limit}
          </Typography>
        </Stack>
        <LinearProgress
          variant="determinate"
          value={progress}
          color={progressColor}
          sx={{ height: 6, borderRadius: 3 }}
        />
        <Stack alignItems="center" sx={{ mt: 1 }}>
          <Button
            size="small"
            variant={quotaInfo.isAtLimit || quotaInfo.isNearLimit ? 'outlined' : 'text'}
            startIcon={<UpgradeIcon />}
            onClick={() => navigate('/settings/subscription')}
            sx={{ textTransform: 'none' }}
          >
            Upgrade to add more {label.toLowerCase()}
          </Button>
        </Stack>
      </Box>
    </Stack>
  );
};

export default QuotaDisplay;
